import React, { useState } from 'react';
import { AppBar, Box, Button, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText, Toolbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, NavLink } from 'react-router-dom';

const links = [['/labs', 'Labs'], ['/about', 'About'], ['/feedback', 'Feedback'], ['/help', 'Help & accessibility']];
export default function Navbar() {
  const [open, setOpen] = useState(false);
  return <>
    <AppBar position="fixed" color="inherit" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Toolbar sx={{ gap: 1, minHeight: { xs: 64 } }}>
        <IconButton sx={{ display: { md: 'none' } }} aria-label="open navigation menu" aria-expanded={open} aria-controls="site-navigation-drawer" onClick={() => setOpen(true)}><MenuIcon /></IconButton>
        <Button component={Link} to="/" sx={{ color: 'text.primary', fontSize: { xs: '1rem', sm: '1.2rem' }, fontWeight: 700 }}>Chem Lab Skills</Button>
        <Box component="nav" aria-label="Primary" sx={{ ml: 'auto', display: { xs: 'none', md: 'block' } }}>
          {links.map(([to, label]) => <Button key={to} component={NavLink} to={to}
            sx={{ color: 'text.primary', '&[aria-current="page"]': { color: 'primary.main', textDecoration: 'underline', textUnderlineOffset: '0.4em' } }}>{label}</Button>)}
        </Box>
      </Toolbar>
    </AppBar>
    <Drawer id="site-navigation-drawer" open={open} onClose={() => setOpen(false)}>
      <Box component="nav" aria-label="Site" sx={{ width: 280, maxWidth: '90vw' }}>
        <IconButton aria-label="close navigation menu" onClick={() => setOpen(false)} sx={{ m: 1 }}><CloseIcon /></IconButton>
        <List>{links.map(([to, label]) => <ListItem key={to} disablePadding><ListItemButton component={NavLink} to={to} onClick={() => setOpen(false)}><ListItemText primary={label} /></ListItemButton></ListItem>)}</List>
      </Box>
    </Drawer>
  </>;
}
